import {
  Divider,
  Popover,
  Stack,
  Typography,
  Badge,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Avatar } from 'requiro-ui-theme';
import { useLauncherStrategyProvider } from 'lib/launchStrategies/LauncherStrategyProvider';
import { useInitProvider } from 'providers/InitProvider';
import { useTranslation } from 'react-i18next';
import Notifications from './Notifications';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { workspacePostCall } from 'components/Workspace';
import styles from './Profile.view.module.css';
import ButtonLabel from './ButtonLabel';
import { getCustomerCareUrl } from 'lib/customerCareUrl';

const WrapperInt = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  padding: '0 0 0 10px',
}));

const WrapperIntMobile = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  padding: '0 0 0 5px',
}));

const ProfileName = styled(Typography)(({ theme }) => ({
  '@media (max-width:780px)': {
    display: 'none',
  },
}));

const searchApp = (dump: any, appName: string) => {
  return dump.apps.findIndex((app) => app.code === appName) === -1
    ? false
    : true;
};

const ProfileView = ({ user, counter, notifications = [] }) => {
  const { launchApplication } = useLauncherStrategyProvider();
  const { dump, amIUsingTheDefaultApp } = useInitProvider();
  const accountExists = searchApp(dump, 'account');
  const { available, current } = dump?.workspace;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>();
  const { t, i18n } = useTranslation();
  const matches = useMediaQuery('(max-width:599px)');

  let channel;
  if ('BroadcastChannel' in window.self) {
    channel = new BroadcastChannel('logout');
    channel.addEventListener('message', (event) => {
      window.open('/rqx/session/logout', '_self');
    });
  } else {
    window.onstorage = () => {
      if (window.localStorage.getItem('Logout') === 'true') {
        window.open('/rqx/session/logout', '_self');
      }
    };
  }

  let name = '-';
  let surname = '-';

  if (user.name) name = user.name;
  if (user.surname) surname = user.surname;
  // const kc = useKeycloak();

  const handleLogout = () => {
    if ('BroadcastChannel' in window.self) {
      channel.postMessage('');
    } else {
      localStorage.setItem('Logout', 'true');
      window.open('/rqx/session/logout', '_self');
    }
  };

  const handleChangeWorkspace = () => {
    console.log('POST AL BACKEND per togliere il current');
    workspacePostCall('');
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'launcher-popover' : undefined;
  const accountAppData = dump.apps.find((item) => item.code === 'account');

  const notificationsLabel =
    counter === 1
      ? t('notifications.onenew', 'You have 1 notification')
      : t('notifications.new', { n: counter });

  useEffect(() => {
    const muiBadgeRoot = document.getElementsByClassName('MuiBadge-root');
    if (muiBadgeRoot.length > 0)
      (muiBadgeRoot[0] as any).style.setProperty(
        'background',
        'transparent',
        'important',
      );
  }, [counter]);

  const white = amIUsingTheDefaultApp() ? { color: 'white' } : {};

  const WrapperComp = matches ? WrapperIntMobile : WrapperInt;

  return (
    <>
      <WrapperComp>
        <Stack direction="row" spacing={1} alignItems="center">
          <ProfileName style={{ fontFamily: 'WotfardLight', ...white }}>
            {name !== '-' && surname !== '-' ? `${name[0]}. ${surname}` : ''}
          </ProfileName>

          <Avatar
            sx={{
              cursor: 'pointer',
              border: '1px solid #bbbcbe !important',
              fontSize: '15px !important',
            }}
            alt={`${name} ${surname}`}
            onClick={handleClick}
            size={48}
          >
            {`${name} ${surname}`}
          </Avatar>
        </Stack>
      </WrapperComp>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Stack direction="column" sx={{ p: 1 }}>
          <Stack direction="row" spacing={1}>
            <ButtonLabel
              icon={<InsertDriveFileIcon />}
              label={t('buttons.jsm', 'Customer Care')}
              onClick={() =>
                window.open(getCustomerCareUrl(i18n?.language), '_blank')
              }
            />
          </Stack>
          <Stack direction="row" spacing={1}>
            <ButtonLabel
              icon={<WorkspacesIcon sx={{ fontSize: 18 }} />}
              label={t('buttons.workspace', 'Workspace')}
              onClick={handleChangeWorkspace}
            />
          </Stack>
          <Stack direction="row" spacing={1}>
            {!accountExists ? (
              <div className={styles.disabled}>
                <ButtonLabel
                  icon={<SettingsIcon />}
                  label={t('buttons.account', 'Account')}
                  onClick={() => launchApplication(accountAppData)}
                />
              </div>
            ) : (
              <ButtonLabel
                icon={<SettingsIcon />}
                label={t('buttons.account', 'Account')}
                onClick={() => launchApplication(accountAppData)}
              />
            )}
          </Stack>
          <Stack direction="row" spacing={2}>
            {
              <ButtonLabel
                icon={<LogoutIcon sx={{ fontSize: 18 }} />}
                label={t('buttons.logout', 'Logout')}
                onClick={handleLogout}
              />
            }
          </Stack>

          {/* {available.length > 1 && current && (
            <>
              <Divider />
              <div
                style={{
                  display: !matches ? 'flex' : 'block',
                  alignItems: 'baseline',
                }}
              >
                <Typography variant="body2" sx={{ fontSize: 18, mr: 1 }}>
                  {t('currentWorkspace', 'You are inside the workspace')}
                </Typography>
                <Typography variant="body1">
                  {available.find((item) => item.code === current)?.name}
                </Typography>
              </div>
              <Stack direction="row" spacing={4}>
                {
                  <ButtonLabel
                    icon={<WorkspacesIcon sx={{ fontSize: 18, mr: 1 }} />}
                    label={t('buttons.workspace', 'Workspace')}
                    onClick={handleChangeWorkspace}
                  />
                }
              </Stack>
            </>
          )}
          <Divider />
          <Typography>{notificationsLabel}</Typography>
          <Notifications
            notifications={notifications}
            handleClose={handleClose}
          /> */}
        </Stack>
      </Popover>
    </>
  );
};

export default ProfileView;
